import { STATES } from 'common/domain/states';

class InitialDataManagerService {
  constructor($http, AuthenticationService, $state, ManagerDataService, FoodBenefitManagerRepositoryService) {
    'ngInject';
    this.$http = $http;
    this.managerId = AuthenticationService.getEmployeeId();
    this.managerRepositoryService = FoodBenefitManagerRepositoryService;
    this.state = $state;
    this.ManagerDataService = ManagerDataService;
  }

  initMainData() {
    return this.managerRepositoryService.getManager(this.managerId)
      .then((manager) => {
        this.ManagerDataService.setManager(manager);
        return manager;
      }, ()=>{
        // TODO: [Manu] este probablemente también sea motivo de error en la APP. Esperamos a confirmación del cliente
        this.state.go(STATES.ERROR);
      });

  }
}

export default InitialDataManagerService;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/initialData/initialDataManager.service.js